<template>
  <div v-if="showModal" :class="['modal', {'modal--dark': darkBackground}]" @click.self="$emit('close')" :style="{ zIndex: zIndex }">
    <div class="modal__container"
         :style="{
          width: modalWidth + 'px',
          height: modalHeight + 'px'
         }">
      <header class="modal__header">
        <div class="modal-icon">
          <p4a-icon :icon="icon"/>
        </div>
        <div class="modal-title">
          <h1>{{title}}</h1>
        </div>
        <div class="modal-close"  @click="$emit('close')">
          <p4a-icon :icon="'close'" />
        </div>
      </header>
      <div :class="modalBodyClass">
        <template v-if="modalBodyClass === 'modal__body--standard'">
          <div class="content">
            <slot></slot>
          </div>
          <div class="button-container">
            <slot name="buttons"></slot>
            <slot name="button-container"></slot>
          </div>
        </template>
        <template v-if="modalBodyClass === 'modal__body--topbar'">
          <div class="topbar">
            <slot name="topbar"></slot>
          </div>
          <div class="content">
            <slot></slot>
          </div>
          <div class="button-container">
            <slot name="buttons"></slot>
          </div>
        </template>
        <template v-if="modalBodyClass === 'modal__body--leftbar'">
          <div class="leftbar">
            <slot name="leftbar"></slot>
          </div>
          <div class="content-wrapper">
            <div class="content">
              <slot></slot>
            </div>
            <div class="button-container">
              <slot name="buttons"></slot>
            </div>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      zIndex: Number,
      modalWidth: Number,
      modalHeight: Number,
      title: {
        type: String,
        required: true
      },
      showModal: {
        type: Boolean,
        required: true
      },
      icon: {
        type: String,
        default: null
      },
      darkBackground: {
        type: Boolean,
        default: true
      },
      template: {
        type: String,
        default: 'standard'
      }
    },

    updated () {
      if (this.showModal) {
        document.addEventListener('keyup', this.closeModal)
      } else {
        document.removeEventListener('keyup', this.closeModal)
      }
    },

    methods: {
      closeModal(event) {
        if (event.key === 'Escape' || event.key === 'Esc' || event.keyCode === 27) {
          this.$emit('close');
        }
      }
    },

    computed: {
      modalBodyClass () {
        switch(this.template.toLowerCase()) {
          case 'standard':
            return 'modal__body--standard'
          case 'topbar':
            return 'modal__body--topbar'
          case 'leftbar':
            return 'modal__body--leftbar'
          default:
            return 'modal__body--standard'
        }
      }
    },


  }
</script>

<style lang="scss" scoped>
  @import '../styling/styling.scss';

  .modal {
    width: 100vw;
    height: 100vh;
    top: 0;
    left: 0;
    display: flex;
    position: fixed;
    align-items: center;
    justify-content: center;

    &--dark { background-color: rgba(0,0,0,0.1); }

    &__container {
      display: flex;
      border-radius: rem(2);
      flex-direction: column;
      background-color: $white;
      box-shadow: 0 0 rem(25) 0 rgba(0,0,0,.2);

      .content { flex: 1; }

      .button-container {
        height:  rem(50);
        display: flex;
        align-items: center;
        margin-top: rem(50);
        justify-content: flex-end;

        .btn { width: rem(150); }
      }
    }

    &__header {
      height: rem(50);
      align-items: center;
      border-bottom: rem(1) solid $dark-grey-background;

      .modal-icon, .modal-close {
        width: rem(50);
        height: rem(50);
        float: left;
        padding: rem(16);
      }

      .modal-close {
        float: right;
        cursor: pointer;
        color: $light-grey-font;

        &:hover { color: $medium-grey-font; }
      }

      .modal-title {
        width: calc(100% - #{rem(100)};
        height: rem(50);
        float: left;
        line-height: rem(25);

        h1 {
          text-align: left;
          font-weight: 300;
          font-size: rem(17);
          color: $medium-grey-font;
        }
      }
    }

    &__body--standard {
      flex: 1;
      display: flex;
      padding: rem(25);
      flex-direction: column;
    }

    &__body--topbar {
      height: 100%;
      display: flex;
      flex-direction: column;
      padding: 0 rem(25) rem(25) rem(25);

      .topbar {
        height: rem(50);
        margin-bottom: rem(25);
      }
    }

    &__body--leftbar {
      height: 100%;
      display: flex;

      .leftbar {
        width: rem(150);
        padding-top: rem(5);
        background-color: $light-grey-background;
        border-right: rem(1) solid $dark-grey-background;
      }

      .content-wrapper {
        width: 100%;
        display: flex;
        padding: rem(25);
        flex-direction: column;
      }
    }
  }

  @media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {
    .modal {
      width: 100vw;
      height: 100vh;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      position: fixed;

      &--dark { background-color: rgba(0,0,0,0.1); }

      &__container {
        width: auto;
        height: 100%;
        margin: rem(100) auto;
        border-radius: rem(2);
        background-color: white;
        box-shadow: 0 0 rem(25) 0 rgba(0,0,0,.2);

        .button-container {
          width: 100%;
          height: rem(50);
          text-align: right;
          margin-top: rem(50);

          .btn { width: rem(150); }
        }
      }

      &__header {
        height: rem(50);
        box-sizing: border-box;
        border-bottom: rem(1) solid $dark-grey-background;

        .modal-icon, .modal-close {
          width: rem(50);
          height: rem(50);
          float: left;
          padding: rem(17);

          svg {
            width: rem(18);
            height: rem(18);
          }
        }

        .modal-close {
          float: right;
          cursor: pointer;
          color: $light-grey-font;

          &:hover { color: $medium-grey-font; }
        }

        .modal-title {
          width: calc(100% - #{rem(100)});
          height: rem(50);
          float: left;

          h1 {
            height: rem(50);
            padding: 0;
            text-align: left;
            font-weight: 300;
            font-size: rem(17);
            line-height: rem(25);
            color: $medium-grey-font;
          }
        }
      }

      &__body--standard { padding: rem(25); }

      &__body--topbar {
        padding: 0 rem(25) rem(25) rem(25);

        .topbar {
          height: rem(50);
          margin-bottom: rem(25);
        }
      }

      &__body--leftbar {
        height: 100%;

        .leftbar {
          width: rem(150);
          float: left;
          padding-top: rem(5);
          margin-top: rem(-23);
          background-color: $light-grey-background;
          border-right: rem(1) solid $dark-grey-background;
        }

        .content-wrapper {
          width: calc(100% - #{rem(150)});
          height: 100%;
          padding: rem(25);
          margin-left: rem(150);
        }
      }
    }
  }

</style>



// WEBPACK FOOTER //
// node_modules/pro4all-ui/ui-kit/components/Modal.vue